import React, { useEffect, useState } from 'react';
import { Menu, Input } from 'antd';
import { useSelector } from 'react-redux';
import { SearchOutlined } from '@ant-design/icons';

const { SubMenu } = Menu;

const Menubar = ({ onSelect, selectedItem }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const security = useSelector((state) => state.data.items[0]);

  // Individual menu items (not grouped)
  const ungroupedMenuItems = [
    { key: 'Object Manager', label: 'Object Manager', permission: true },
    { key: 'Custom Tabs', label: 'Custom Tabs', permission: true },
    { key: 'Pipelines', label: 'Pipelines', permission: true },
    { key: 'Recycle bin', label: 'Recycle bin', permission: security?.system_settings?.recycle_bin?.view },
    { key: 'Organisation Setup', label: 'Organisation Setup', permission: security?.system_settings?.organisation_setup?.view },
    { key: 'System Connectors', label: 'System Connectors', permission: true },
    {key: 'Custom Connectors', label: 'Custom Connectors', permission: true},
  ];

  // Grouped menu items
  const groupedMenuItems = [
    {
      group: 'User Management',
      items: [
        { key: 'Users', label: 'Users', permission: security?.object_settings?.User?.object_setting?.view},
        { key: 'Groups', label: 'Groups',  permission: security?.system_settings?.user_group?.view },
        { key: 'Roles', label: 'Roles', permission: security?.system_settings?.user_role?.view },
      ],
    },
    {
      group: 'Security',
      items: [
        { key: 'Access Policy', label: 'Access Policy', permission: security?.system_settings?.access_policy?.view },
        { key: 'Access Policy Group', label: 'Access Policy Group', permission: security?.system_settings?.access_policy_group?.view },
      ],
    },
    {
      group: 'Automation & Reports',
      items: [
        { key: 'Approval Process', label: 'Approval Processes', permission: security?.system_settings?.approval_process?.view },
        { key: 'Reports', label: 'Reports', permission: security?.system_settings?.report?.view },
        { key: 'Schedule Jobs', label: 'Schedule Jobs', permission: security?.system_settings?.schedule_job?.view },
      ],
    },
    {
      group: 'Data & Templates',
      items: [
        { key: 'Import Wizard', label: 'Import Wizard', permission: security?.system_settings?.import_records?.view },
        { key: 'Email Template', label: 'Email Templates', permission: security?.system_settings?.email_template?.view },
      ],
    },
    {
      group: 'Customization',
      items: [
        { key: 'Classes', label: 'Classes', permission: security?.system_settings?.ruby_class?.view },
        { key: 'App-Manager', label: 'App Manager', permission: security?.system_settings?.ruby_class?.view },
        { key: 'Plugins', label: 'Plugins', permission: security?.system_settings?.ruby_class?.view },
      ],
    },
    {
      group: 'Organisation',
      items: [
        { key: 'Manage Currency', label: 'Manage Currency',permission: security?.system_settings?.manage_currencies?.view  },
        { key: 'Dashboards', label: 'Dashboards', permission: security?.system_settings?.dashboard?.view },
        { key: 'Organisation-Wide Defaults', label: 'Organisation-Wide Defaults', permission: security?.system_settings?.organization_wide_defaults?.view },
         
      ],
    },
    // {
    //   group: 'Integration',
    //   items: [  
    //       { key: 'Models', label: 'Models', permission: true }, 
    //   ],
    // },
    {
      group: 'Audit',
      items: [
        { key: 'Audit Logs', label: 'Audit Logs', permission: true },
      ],
    },
  ];

  // Filtered ungrouped items
  const filteredUngrouped = ungroupedMenuItems.filter(
    (item) =>
      item.permission !== false &&
      item.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Filtered grouped items
  const filteredGroups = groupedMenuItems
    .map((group) => {
      const filteredItems = group.items.filter(
        (item) =>
          item.permission !== false &&
          item.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
      return { ...group, items: filteredItems };
    })
    .filter((group) => group.items.length > 0); // Remove empty groups

  return (
    <div style={{ backgroundColor: 'white', height: '100%'}}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '15px' }}>
        <Input
          placeholder="Quick Find"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ height: '15%', width: '90%' }}
          prefix={<SearchOutlined style={{ color: '#999' }} />}
        />
      </div>

      <Menu
        mode="inline"
        onClick={(e) => onSelect(e.key)}
        selectedKeys={[selectedItem]}
        defaultOpenKeys={groupedMenuItems.map((group) => group.group)}
        style={{ height: '90%', overflowY: 'auto' }}
        className="custom-menu custom-scrollbar"
      >
        {/* Render ungrouped items first */}
        {filteredUngrouped.map((item) => (
          <Menu.Item key={item.key}  >{item.label}</Menu.Item>
        ))}

        {/* Render grouped items with collapsible headers */}
        {filteredGroups.map((group) => (
          <SubMenu key={group.group} title={group.group}>
            {group.items.map((item) => (
              <Menu.Item key={item.key}>{item.label}</Menu.Item>
            ))}
          </SubMenu>
        ))}

        {/* Fallback if no items match */}
        {filteredUngrouped.length === 0 && filteredGroups.length === 0 && (
          <Menu.Item disabled style={{ textAlign: 'center', color: '#999' }}>
            No matching items found
          </Menu.Item>
        )}
      </Menu>
    </div>
  );
};

export default Menubar;